import verifiedSuccess from "../assets/images/verifiedSuccess.svg";
import { useTranslation } from "react-i18next";

function VerifiedSuccess() {
  const { t } = useTranslation();

  return (
    <>
      <div className="content-page">
        <div className="success-verified">
          <div className="verified-message">
            <img
              className="verified-success-img"
              src={verifiedSuccess}
              alt="verified-success"
            />
            <div>
              {t("verifiedSuccess.welcomeMessage")}
              <br />
              {t("verifiedSuccess.informationMessage")}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VerifiedSuccess;
